// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «З’їзди й засідання» (Congresses & Meetings, ключ `cng`, група `party-and-group`). */
export const congressesAndMeetingsManifest: IModuleManifest = {
  key: 'cng',
  group: 'party-and-group',
  slug: 'congresses-meetings',
  prefix: 'CNG',
  name: { en: 'Congresses & Meetings', uk: 'З’їзди й засідання' },
  entities: [
    { key: 'cng', slug: 'cng', name: { en: 'Congresses & Meetings', uk: 'З’їзди й засідання' }, main: true },
    { key: 'meeting_delegate', slug: 'meeting-delegate', name: { en: 'Meeting Delegates', uk: 'Делегати' }, main: false },
    { key: 'cng_meeting_agenda_item', slug: 'cng-meeting-agenda-item', name: { en: 'Meeting Agenda Items', uk: 'Пункти порядку денного' }, main: false },
    { key: 'cng_meeting_decision', slug: 'cng-meeting-decision', name: { en: 'Meeting Decisions', uk: 'Рішення' }, main: false },
  ],
  loadState: () => import('./state/congressesAndMeetingsSlice').then((m) => m.congressesAndMeetingsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
